import { Context } from "Context";
import { useContext, Fragment } from "react";
import appConfig from "config.json";

import { Link } from "@wdpr/groot-components";

const { brands } = appConfig;
const syndicatedNavigationClass = "syndicated-navigation";
const syndicatedNavigationNavClass = `${syndicatedNavigationClass}__nav`;

const Logo = ({ onLoadCallback = null, moveLeft = false }) => {
	const {
		config: {
			basePath,
			brand,
			locale,
			logo,
			logoRedirect,
			overrideLogo,
			store,
			defaultLocale,
			absoluteLinksFromBrand,
			logoUrl,
		},
		headerData: { logo: cmsLogo },
	} = useContext(Context);

	let brandLogoSrc = logoUrl;
	let crossOrigin = "anonymous";
	if (!overrideLogo && cmsLogo?.image?.url) {
		brandLogoSrc = cmsLogo?.image?.url;
		crossOrigin = "";
	}
	const brandLogo = (
		<img
			src={brandLogoSrc}
			alt={`${brands[brand]?.name} Logo`}
			loading="eager"
			decoding="sync"
			fetchpriority="high"
			onLoad={onLoadCallback}
			{...(crossOrigin ? { crossOrigin } : {})}
		/>
	);
	const brandLogoClasses = `${syndicatedNavigationNavClass}__logo ${syndicatedNavigationNavClass}__logo--${brand} ${syndicatedNavigationNavClass}__logo--${brand}--${locale}${
		logo ? "" : ` ${syndicatedNavigationNavClass}__logo--hide`
	}${moveLeft ? ` ${syndicatedNavigationNavClass}__logo--move-left` : ""}`;

	const determineHref = () => {
		const currentLocalePath = locale !== defaultLocale ? `/${locale}` : "";
		const defaultHref = `${window?.location.origin}${basePath}${
			basePath ? "/" : ""
		}`;
		if (absoluteLinksFromBrand) return basePath;
		if (brands[brand]?.preventLocalizeLogo) return defaultHref;
		const logoRedirectUrl = brands[brand]?.logoRedirectUrl || "";
		const shouldLocalizeUrls = brands[brand]?.shouldLocalizeUrls !== false;
		const cmsLink = cmsLogo?.webLinks?.[0]?.href;
		if (cmsLink && cmsLink !== "/" && !cmsLink.startsWith("http")) {
			return `${cmsLink}`;
		}
		if (logoRedirectUrl || !shouldLocalizeUrls) {
			const brandPath = logoRedirectUrl ? `${logoRedirectUrl}/` : "";
			return `${defaultHref}${currentLocalePath}/${brandPath}`;
		}
		return defaultHref;
	};

	const renderBrandLogo = () => {
		return !logoRedirect || store ? (
			<div
				className={`${brandLogoClasses} ${syndicatedNavigationNavClass}__logo--no-pointer`}
			>
				{brandLogo}
			</div>
		) : (
			<Link
				href={determineHref()}
				className={brandLogoClasses}
				ariaLabel={`${brands[brand]?.name} Logo`}
			>
				{brandLogo}
			</Link>
		);
	};

	return (
		<Fragment>
			{renderBrandLogo()}
			<div id="logoSchema" itemType="http://schema.org/Organization">
				<link itemProp="url" href={window?.location.origin} />
				<link itemProp="logo" href={brandLogoSrc} />
			</div>
		</Fragment>
	);
};

export default Logo;
